

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { PeriodicService } from '@/data/models/periodicservice.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider,
	},
})
export default class ServizioPeriodicoNote extends Vue {
	@Prop() periodicservice!: PeriodicService;
	@Prop() editable!: boolean;

	constructor() {
		super();
	}

	submit() {
		this.$emit('submit');
	}

}
